import * as actions from './tarefas.action';
import inicialState from './tarefas.state';

const tarefasReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.PENDENTE_DE_REVISAO_COUNT:
      return {
        ...state,
        pendentesDeRevisaoCount: action.payload.pendentesDeRevisaoCount
      };
    case actions.REVISADOS_CONCLUIDOS_COUNT:
      return {
        ...state,
        revisadosConcluidosCount: action.payload.revisadosConcluidosCount
      };
    case actions.PERIODO_INICIAL:
      return {
        ...state,
        periodoInicial: action.payload.periodoInicial
      };
    case actions.PERIODO_FINAL:
      return {
        ...state,
        periodoFinal: action.payload.periodoFinal
      };
    case actions.LISTAGEM_KANBAM:
      return {
        ...state,
        listaKanbam: action.payload.listaKanbam
      };
    case actions.MEDICOS:
      return {
        ...state,
        medicos: action.payload.medicos
      };
    case actions.MEDICO_SELECIONADO:
      return {
        ...state,
        medicoSelecionado: action.payload.medicoSelecionado
      };

    case actions.TIPOS_EXAME:
      return {
        ...state,
        tiposExame: action.payload.tiposExame
      };
    case actions.TIPO_FILTRO:
      return {
        ...state,
        tipoFiltro: action.payload.tipoFiltro
      };
    case actions.TIPO_FILTRO_VALUE:
      return {
        ...state,
        tipoFiltroValue: action.payload.tipoFiltroValue
      };
    case actions.TRIPO_FILTRO_SELECIONADO:
      return {
        ...state,
        tipoFiltroSelecionado: action.payload.tipoFiltroSelecionado
      };
    case actions.OPTIONS_FILTRO_INPUT_TYPE_SELECT:
      return {
        ...state,
        optionsFiltroInputTypeSelect:
          action.payload.optionsFiltroInputTypeSelect
      };
    case actions.OPTION_FILTRO_INPUT_TYPE_SELECT_SELECIONADA:
      return {
        ...state,
        optionFiltroInputTypeSelectSelecionada:
          action.payload.optionFiltroInputTypeSelectSelecionada
      };
    case actions.PREVIEW:
      return {
        ...state,
        preview: action.payload.preview
      };
    case actions.LAUDO:
      return {
        ...state,
        laudo: action.payload.laudo
      };
    case actions.IS_FIRST_LOAD:
      return {
        ...state,
        isFirstLoad: action.payload.isFirstLoad
      };
    case actions.ORDENACAO:
      return {
        ...state,
        ordenacao: action.payload.ordenacao
      };

    default:
      return state;
  }
};

export default tarefasReducer;



// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.reducer.js